import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';
import DisplayAddress from '~spa/classes/DisplayAddress';
import Contact from '~spa/api/app/contact/models/Contact';
    
export default class Opportunity extends BaseModel
{

    static getPrefix()
    {
        return 'worksite:opportunity';
    }

    static getEndpoint()
    {
        return window.Worksite.endpoints.opportunity;
    }

    getRoute()
    {
        return {name: 'account.opportunity.homepage', params: {
            account: window.App.$store.state.account.uuid,
            opportunity: this.uuid
        }};
    }

    containsUndefinedUsers()
    {
        return this.getUsersWithUndefined().length > this.getUsers().length;
    }

    getManagersWithUndefined()
    {
        return this.managers_id.map(id => {
            return window.App.$store.state.models.users.find(user => user.id == id);
        });
    }

    getManagers()
    {
        return this.getManagersWithUndefined().filter(u => u !== undefined);
    }

    getManagersName()
    {
        return this.getManagers().map(user => user.getDisplayName()).join(', ');
    }

    getUsersWithUndefined()
    {
        return this.users_id.map(id => {
            return window.App.$store.state.models.users.find(user => user.id == id);
        });
    }

    getUsers()
    {
        return this.getUsersWithUndefined().filter(u => u !== undefined);
    }

    getUsersName()
    {
        return this.getUsers().map(user => user.getDisplayName()).join(', ');
    }

    async getFullContact()
    {
        if ( ! this.contact ) {
            return;
        }

        if ( this.contact.full ) {
            return this.contact;
        }

        this.contact = await new Contact().show(this.contact_uuid);
        this.contact.full = true;
    }

    getContactAddress()
    {
        if ( ! this.contact ) {
            return null;
        }

        return new DisplayAddress({
            street_name: this.contact.address_line_1,
            street_number: this.contact.address_line_2,
            city: this.contact.city,
            postal_code: this.contact.postal_code,
        }).get();
    }

    getContactName()
    {
        if ( this.contact ) {
            return this.contact.name;
        }
        if ( this.contact_uuid ) {
            return window.App.$t('worksite.contact.not_found');
        }
        return window.App.$t('worksite.contact.empty');
    }

    getStatuses()
    {
        return ['pending', 'contact', 'meeting', 'quote'];
    }
    
    hasOrPassedStatus(status, currentStatus = null)
    {
        return this.getStatuses().findIndex((s) => s === (currentStatus || this.status)) >= this.getStatuses().findIndex((s) => s === status);
    }

    getAddress()
    {
        return new DisplayAddress(this.address).get();
    }

    async getQuotes()
    {
        let quotes = await Promise.all(
            this.quotes_uuid.map(
                async (uuid) => window.App.$spa.TrustUpPro.getQuote(uuid)
            )
        );
        return quotes.filter(q => q !== null);
    }

    async transformToWorksite(quotes = null)
    {
        let worksite = await this.getEndpoint().transformToWorksite(this.uuid);

        if ( ! quotes ) {
            return worksite;
        }

        // TODO: Needs to be refactored. We should do all of that in the back-end.
        // Right now, if the opportunity is duplicated before the quotes are retrieved, they won't be copied to the worksite.
        // Same if, for whatever reason, a quote fails to load...
        let promises = [];
        for ( let i = 0; i < quotes.filter(q => q.status_key !== 'draft').length; i++ ) {
            promises.push(
                window.Worksite.endpoints.worksiteProfitabilityDocument
                    .setWorksite(worksite)
                    .store({
                        type: 'quote',
                        status: quotes[i].status_key,
                        amount: quotes[i].total,
                        sent_at: window.moment(quotes[i].sent_at).format('YYYY-MM-DD'),
                        pdf: quotes[i].pdf,
                        number: quotes[i].number,
                        external_uuid: quotes[i].uuid,
                        external_account_uuid: window.App.$spa.TrustUpPro.getAccountUuid('invoicing'),
                        external_source: 'invoicing',
                    })
            );
        }

        await Promise.all(promises);

        return worksite;
    }

}